import { IFullUserInfo } from '@/services/types/user/user';

import { PaymentMethods } from './PaymentMethods/PaymentMethods';
interface IProps {
  userData: IFullUserInfo;
}

export const Payment = ({ userData }: IProps) => {
  return <PaymentMethods user={userData} />;
};
